module.exports = __webpack_public_path__ + "assets/img/21_754.2073622d.jpg";